import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LenderClientKebebOptionTypes } from '@components/lender-card/client-lender-card/client-lender-card.component';
import { ICON } from '@core/util/icon';
import { BusinessClient, PersonClient } from '@models/clients';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { NavigationService } from '@services/nav/nav.service';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { GlobalProfileComponent } from 'src/app/private/global-profile/global-profile.component';
import {
	DropdownOption,
	DropdownResult,
} from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { DrawerService } from 'src/app/ui/drawer/drawer.service';

export enum InvestorKebabOptionTypes {
	VIEW_GLOBAL_PROFILE = 'VIEW_GLOBAL_PROFILE',
	REMOVE = 'REMOVE',
}

@Component({
	selector: 'app-investor-card',
	templateUrl: './investor-card.component.html',
	standalone: false,
})
export class InvestorCardComponent {
	@Input() client: PersonClient | BusinessClient;

	@Output() onRemoveLender = new EventEmitter<void>();

	@SelectSnapshot(SelectedMatter.id) matterId: string;

	public ICON = ICON;

	public InvestorKebabOptions: DropdownOption<InvestorKebabOptionTypes>[] = [
		{
			name: 'View global profile',
			value: InvestorKebabOptionTypes.VIEW_GLOBAL_PROFILE,
			icon: ICON.EDIT,
		},
		{
			name: 'Remove',
			value: InvestorKebabOptionTypes.REMOVE,
			classes: ['text-red'],
			icon: ICON.DELETE,
		},
	];

	constructor(
		private navigationService: NavigationService,
		private drawerService: DrawerService,
	) {}

	onKebabSelect(
		clientId: string,
		$event: DropdownResult<DropdownOption<LenderClientKebebOptionTypes>>,
	) {
		if ($event.result.value === LenderClientKebebOptionTypes.REMOVE) {
			this.onRemoveLender.emit();
		} else if (
			$event.result.value === LenderClientKebebOptionTypes.VIEW_GLOBAL_PROFILE
		) {
			this.drawerService.openDrawer(GlobalProfileComponent, {
				title: 'Global Profile',
				data: { clientId: clientId },
			});
		}
	}
}
